import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const REMOVE_INTERNAL_BANNER_IMAGE = 'REMOVE_INTERNAL_BANNER_IMAGE';
export type REMOVE_INTERNAL_BANNER_IMAGE = typeof REMOVE_INTERNAL_BANNER_IMAGE;
export interface RemoveInternalBannerImage {
    type: REMOVE_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}
export function removeInternalBannerImageAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): RemoveInternalBannerImage {
    return {
        type: REMOVE_INTERNAL_BANNER_IMAGE,
        bannerId,
        resourceId
    };
}
